export {TeamPage} from './TeamPage';
export {TeamPage as TeamPageNew} from './TeamPageNew';
